<template>
  <div class="multi-step-form-clean">
    <div class="onboarding-topbar d-flex justify-content-between align-items-center">
      <button
        class="onboarding-topbar-btn onboarding-topbar-btn-home btn-sm border-0 rounded bg-transparent d-flex align-items-center fw-bold text-dark"
        @click="$router.push('/view_all_user_forms')"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Go back to job posts"
      >
        <i class='bi bi-house fs-3 icon-white '></i>
      </button>

      <div v-if="show_advert_timer_panel" class="advert-timer-panel topbar-advert-timer">
        <div class="advert-timer-countdown" :class="{ closed: advert_countdown_state === 'closed' }">
          <span class="advert-timer-label">{{ advert_countdown_label }}</span>
          <div v-if="advert_countdown_parts" class="advert-timer-time" aria-live="polite">
            <span class="advert-time-unit">
              <strong>{{ advert_countdown_parts.days }}</strong>
              <small>DD</small>
            </span>
            <span class="advert-time-separator" aria-hidden="true">:</span>
            <span class="advert-time-unit">
              <strong>{{ advert_countdown_parts.hours }}</strong>
              <small>HRS</small>
            </span>
            <span class="advert-time-separator" aria-hidden="true">:</span>
            <span class="advert-time-unit">
              <strong>{{ advert_countdown_parts.minutes }}</strong>
              <small>MIN</small>
            </span>
            <span class="advert-time-separator" aria-hidden="true">:</span>
            <span class="advert-time-unit">
              <strong>{{ advert_countdown_parts.seconds }}</strong>
              <small>SEC</small>
            </span>
          </div>
          <strong v-else class="advert-timer-fallback">{{ advert_countdown_text }}</strong>
        </div>
      </div>

      <button
        class="onboarding-topbar-btn btn btn-sm rounded-small text-xs shadow  btn-primary-dark d-flex align-items-center"
        @click="save_and_logout"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Save & Exit"
      >

        <span class="text-xs">Save &amp; Exit</span>
      </button>

    </div>
    <div class="forms-container" v-if="show_profile_completion_gate">
      <div class="form-wrapper active">
        <div class="form-card-clean shadow-sm">
          <div class="form-header mt-2 text-xs">
            Profile Completed
          </div>
          <div class="form-fields-container p-4 text-center">
            <div class="d-flex justify-content-center mb-2">
              <span class="badge  text-dark border text-xs px-3 py-2">
                Step 1 of 2 complete
              </span>
            </div>
            <div class="progress mb-3 profile-completion-progress">
              <div
                class="progress-bar bg-success profile-completion-progress-bar"
                role="progressbar"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <div class="alert alert-success text-xs mb-4" role="alert">
              {{ profile_completion_gate_message || 'Profile completed. Continue to fill your job application and submit, then apply for more jobs.' }}
            </div>
            <div class="d-flex justify-content-center flex-wrap gap-3">
              <button
                v-if="profile_gate_mode === 'choice'"
                class="btn btn-sm text-xs shadow btn-primary-dark"
                @click="view_and_update_profile"
              >
                View and Update Profile
              </button>
              <button
                v-if="profile_gate_mode === 'choice' && gate_can_preview"
                class="btn btn-sm text-xs shadow btn-primary-dark"
                @click="preview_complete_application"
                :disabled="preview_blocked_by_required_confirmation"
              >
                Preview
              </button>
              <button
                class="btn btn-sm text-xs shadow btn-primary-dark"
                @click="proceed_to_complete_application"
              >
                Proceed to Complete Application
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="forms-container" v-else-if="is_loading_form">
      <div class="form-wrapper active">
        <div class="form-card-clean shadow-sm">
          <div class="form-fields-container p-5 text-center">
            <div class="spinner-border text-primary mb-3" role="status" aria-hidden="true"></div>
            <div class="text-xs fw-bold">Checking application...</div>
          </div>
        </div>
      </div>
    </div>

    <div class="forms-container" v-else>
      <div class="onboarding-shell ">
        <aside class="onboarding-sidebar">
          <div class="sidebar-brand">
            <div class="brand-text-wrap">
              <a class="mt-2 d-inline-flex align-items-center">
                <img :src="$clientLogo" alt="Logo" class="logo-img" width="150px">
              </a>
            </div>
          </div>

          <div class="sidebar-divider"></div>
          <div class="sidebar-caption text-x fw-bold mb-3 ">Application Steps</div>

          <div class="sidebar-step-list" v-if="safe_form_config.sections && safe_form_config.sections.length">
            <div class="sidebar-step-list text-x">
              <button
                v-for="(navSection, navIndex) in safe_form_config.sections"
                :key="'sidebar-section-' + navIndex"
                type="button"
                class="sidebar-step-btn"
                :class="{ active: navIndex === current_section_index }"
                @click="goToSection(navIndex)"
              >
                <span class="sidebar-step-number text-x ">{{ get_sidebar_step_label(navIndex) }}</span>
                <span class="text-x">{{ navSection.title || ('Step ' + (navIndex + 1)) }}</span>
              </button>
            </div>
          </div>

          <div
            class="mobile-progress-wrapper"
            v-if="safe_form_config.sections && safe_form_config.sections.length > 0"
          >
            <div class="progress-track mt-3">
              <div
                class="progress-fill"
                :style="{ width: ((current_section_index + 1) / safe_form_config.sections.length * 100) + '%' }"
              ></div>
            </div>
          </div>

          
        </aside>

        <main class="onboarding-main">
          <div v-if="inline_form_notice_text" class="mb-3 w-100">
            <div
              class="alert text-xs mb-0 rounded-3"
              :class="inline_form_notice_type === 'success' ? 'alert-success' : 'alert-info'"
              role="alert"
            >
              {{ inline_form_notice_text }}
            </div>
          </div>

          <div
            class="mobile-dots"
            v-if="safe_form_config.sections && safe_form_config.sections.length > 0 && !show_form_preview"
          >
            <button
              v-for="(_, dotIndex) in safe_form_config.sections"
              :key="'mobile-dot-' + dotIndex"
              type="button"
              class="mobile-dot"
              :class="{ active: dotIndex === current_section_index }"
              @click="goToSection(dotIndex)"
              :aria-label="'Go to step ' + (dotIndex + 1)"
            ></button>
          </div>

          <div
            class="mobile-step-header"
            v-if="safe_form_config.sections && safe_form_config.sections.length > 0 && !show_form_preview"
          >
            <div class="mobile-step-title">
              {{ safe_form_config.sections[current_section_index]?.title || ('Step ' + (current_section_index + 1)) }}
            </div>
            <div class="mobile-step-row">
              <span class="mobile-step-label">{{ current_section_index + 1 }} of {{ safe_form_config.sections.length }}</span>
              <div class="mobile-step-track">
                <div
                  class="mobile-step-fill"
                  :style="{ width: ((current_section_index + 1) / safe_form_config.sections.length * 100) + '%' }"
                ></div>
              </div>
            </div>
          </div>

          <div class="carousel-container" ref="carousel">
            <div v-for="(section, section_index) in safe_form_config.sections" :key="'section-' + section_index"
              v-show="!show_form_preview" class="form-wrapper" :class="{ active: section_index === current_section_index }"
              :data-index="section_index">
              <div class="form-header-clean px-4">
                <div class="progress-wrapper mb-5" v-if="safe_form_config.sections && safe_form_config.sections.length > 0">
                  <div class="progress-track">
                    <div
                      class="progress-fill"
                      :style="{ width: ((section_index + 1) / safe_form_config.sections.length * 100) + '%' }"
                    ></div>
                  </div>
                <span class="progress-text form-step-text-mobile-hidden">
                  Step {{ section_index + 1 }} of {{ safe_form_config.sections.length }}
                </span>
                </div>
              </div>

              <div class="form-header-top d-md-none">
                <div class="header-nav-actions">
                  <button
                    class="nav-arrow nav-prev btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark d-flex align-items-center fw-bold"
                    @click="goToPrevSection"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Previous Section"
                    :disabled="current_section_index === 0"
                    v-if="safe_form_config.sections?.length > 1">
                    <i class="bi bi-chevron-left"></i>
                    <span class="nav-arrow-label">Back</span>
                  </button>

                  <button
                    class="nav-arrow nav-next btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark d-flex align-items-center fw-bold"
                    @click="goToNextSection"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Next Section"
                    v-if="section_index !== safe_form_config.sections.length - 1 && safe_form_config.sections?.length > 1">
                    <i class="bi bi-chevron-right"></i>
                    <span class="nav-arrow-label">Continue</span>
                  </button>
                </div>
              </div>

              <div class="form-card-clean" v-if="safe_form_config">
                <template v-if="safe_form_config.sections && safe_form_config.sections.length">
                  <div class="section-container mt-3" :class="{
                      active: section_index === current_section_index,
                      inactive: section_index !== current_section_index
                    }">
                    <div
                      class="form-fields-container"
                      v-if="(section.fields && section.fields.length)
                        || (section.is_work_experience && work_experience_blocks[section.id])
                        || (section.has_language_cards && language_blocks[section.id])
                        || (section.has_education_cards && education_blocks[section.id])
                        || (section.has_reference_cards && reference_blocks[section.id])"
                    >
                      
                      <div class="section-heading  border-bottom" v-if="section.title">
                        <span class="d-flex align-items-center gap-2 text-x mt-2 fw-bold">
                          {{ section.title }}
                          <i :class="[
                              section.is_verified ? 'bi bi-check-circle text-success' : 'bi bi-exclamation-circle text-danger',
                              'fs-6'
                            ]">
                          </i>
                        </span>
                      </div>

                      <template v-if="section.is_work_experience && work_experience_blocks[section.id]">
                        <div
                          class="we-block-card mb-4 p-4 border rounded-3"
                          v-for="(block, bidx) in work_experience_blocks[section.id]"
                          :key="'we-block-' + section.id + '-' + bidx"
                        >
                          <div class="we-block-header d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                            <p class="d-none fw-bold text-xs mb-0 text-dark">
                              <i class="bi bi-building me-1"></i>
                              {{ block.label }}
                            </p>
                            <button
                              v-if="work_experience_blocks[section.id].length > 1"
                              type="button"
                              class="btn btn-sm border-0 text-danger"
                              @click="remove_experience_block(section.id, bidx)"
                              title="Remove this experience"
                            >
                              <i class="bi bi-trash"></i>
                            </button>
                          </div>

                          <div class="we-fields-grid row g-3">
                            <template v-for="(field, fidx) in block.fields" :key="'we-f-' + bidx + '-' + fidx">

                              <div
                                v-if="field.type === 'we_month'"
                                v-show="!block.currently_work_here || !field.label.toLowerCase().startsWith('to ')"
                                class="we-form-group col-6 col-md-6"
                                :data-field-model="field.model"
                                :class="{ 'we-date-field': ['From Month', 'To Month'].includes(field.label) }"
                              >
                                <label class="form-label fw-medium text-xs text-start d-block">{{ field.label }} <span v-if="field.required" class="text-danger fs-4">*</span></label>
                                <select
                                  class="form-select form-select-sm text-xs  border-1 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  v-model="safe_form_data[field.model]"
                                  :required="field.required"
                                  @change="!field.label.toLowerCase().startsWith('to ') && _on_we_from_changed(block)"
                                >
                                  <option value="" disabled>Month</option>
                                  <option v-for="mo in (field.label.toLowerCase().startsWith('to ') ? _get_we_to_month_options(block) : _get_we_month_options())" :key="'mo-' + mo.value" :value="mo.value">{{ mo.text }}</option>
                                </select>
                                <div v-if="validation_errors[field.model]" class="d-none text-danger text-xs mt-1">{{ validation_errors[field.model] }}</div>
                              </div>

                              <div
                                v-else-if="field.type === 'we_year'"
                                v-show="!block.currently_work_here || !field.label.toLowerCase().startsWith('to ')"
                                class="we-form-group col-6 col-md-6"
                                :data-field-model="field.model"
                                :class="{ 'we-date-field': ['From Year', 'To Year'].includes(field.label) }"
                              >
                                <label class="form-label fw-medium text-xs text-start d-block">{{ field.label }} <span v-if="field.required" class="text-danger fs-4">*</span></label>
                                <select
                                  class="form-select form-select-sm text-xs  border-1 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  v-model="safe_form_data[field.model]"
                                  :required="field.required"
                                  @change="!field.label.toLowerCase().startsWith('to ') && _on_we_from_changed(block)"
                                >
                                  <option value="" disabled>Year</option>
                                  <option v-for="yr in (field.label.toLowerCase().startsWith('to ') ? _get_we_to_year_options(block) : _get_we_year_options())" :key="'yr-' + yr.value" :value="yr.value">{{ yr.text }}</option>
                                </select>
                                <div v-if="validation_errors[field.model]" class="d-none text-danger text-xs mt-1">{{ validation_errors[field.model] }}</div>
                              </div>

                              <div
                                v-else-if="field.type === 'textarea'"
                                v-show="!block.currently_work_here || !field.label.toLowerCase().includes('reason for leaving')"
                                class="we-form-group col-12"
                                :data-field-model="field.model"
                              >
                                <label class="form-label fw-medium text-xs text-start d-block" v-if="field.label">{{ field.label }} <span v-if="field.required" class="text-danger fs-4">*</span></label>
                                <textarea
                                  class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg"
                                  v-model="safe_form_data[field.model]"
                                  :placeholder="field.placeholder"
                                  rows="2"
                                  maxlength="200"
                                ></textarea>
                                <div v-if="validation_errors[field.model]" class="text-danger text-xs mt-1">{{ validation_errors[field.model] }}</div>
                              </div>

                              <div v-else class="we-form-group col-md-12" :data-field-model="field.model">
                                <label class="form-label fw-medium text-xs text-start d-block" v-if="field.label">{{ field.label }} <span v-if="field.required" class="text-danger fs-4">*</span></label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  v-model="safe_form_data[field.model]"
                                  :placeholder="field.placeholder"
                                  :required="field.required"
                                  maxlength="100"
                                />
                                <div v-if="validation_errors[field.model]" class="text-danger text-xs mt-1">{{ validation_errors[field.model] }}</div>
                              </div>

                            </template>
                          </div>

                          <div v-if="_get_we_date_error(section.id, bidx)" class="text-danger text-xs mt-1 mb-2">
                            <i class="bi bi-exclamation-circle me-1"></i>{{ _get_we_date_error(section.id, bidx) }}
                          </div>

                          <div class="form-check we-current-checkbox mt-2 pt-2 ">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              :id="'cwh_' + section.id + '_' + bidx"
                              :checked="block.currently_work_here"
                              @change="toggle_currently_work_here(section.id, bidx)"
                            />
                            <label class="form-check-label text-xs text-dark" :for="'cwh_' + section.id + '_' + bidx">
                              I currently work here
                            </label>
                          </div>
                        </div>

                        <div class="text-center mt-2 mb-3" v-if="(work_experience_blocks[section.id] || []).length < (_all_we_blocks_by_section && _all_we_blocks_by_section[section.id] ? _all_we_blocks_by_section[section.id].length : 0)">
                          <button
                            type="button"
                            class="btn btn-sm text-xs shadow btn-primary-dark"
                            @click="add_experience_block(section.id)"
                          >
                            Add another employer
                          </button>
                        </div>
                      </template>

                      <template v-if="section.has_language_cards && language_blocks[section.id]">
                        <div
                          class="we-block-card mb-4 p-4 border rounded-3"
                          v-for="(block, bidx) in language_blocks[section.id]"
                          :key="'lang-block-' + section.id + '-' + bidx"
                        >
                          <div class="we-block-header d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                            <p class="d-none fw-bold text-xs mb-0 text-dark">
                              <i class="bi bi-translate me-1"></i>
                              {{ block.label }}
                            </p>
                            <button
                              v-if="language_blocks[section.id].length > 1"
                              type="button"
                              class="btn btn-sm border-0 text-danger"
                              @click="remove_language_block(section.id, bidx)"
                              title="Remove this language"
                            >
                              <i class="bi bi-trash"></i>
                            </button>
                          </div>

                          <div class="we-fields-grid row g-3">
                            <div v-for="(field, fidx) in block.fields" :key="'lang-field-' + bidx + '-' + fidx" class="we-form-group col-md-4" :data-field-model="field.model">
                              <label class="form-label fw-medium text-xs text-start d-block">{{ field.label }} <span v-if="field.required" class="text-danger">*</span></label>
                              <select
                                v-if="field.type === 'single_select'"
                                class="form-select form-select-sm text-xs  border-1 py-1 rounded-lg"
                                :class="{'border-danger': validation_errors[field.model]}"
                                v-model="safe_form_data[field.model]"
                                :required="field.required"
                              >
                                <option value="">Select...</option>
                                <option v-for="opt in _get_language_field_options(section.id, field)" :key="'opt-' + field.model + '-' + opt.value" :value="opt.value">{{ opt.text }}</option>
                              </select>
                              <input
                                v-else
                                type="text"
                                class="form-control form-control-sm text-xs  border-1 py-1 rounded-lg"
                                :class="{'border-danger': validation_errors[field.model]}"
                                v-model="safe_form_data[field.model]"
                                :placeholder="field.placeholder || field.label"
                                :required="field.required"
                                maxlength="100"
                              />
                              <input
                                v-if="field.allows_other && (safe_form_data[field.model] || '').toLowerCase() === 'other'"
                                type="text"
                                class="form-control form-control-sm text-xs  border-1 py-1 rounded-lg mt-2"
                                :data-field-model="field.other_model"
                                :class="{'border-danger': validation_errors[field.other_model]}"
                                v-model="safe_form_data[field.other_model]"
                                placeholder="Please specify"
                                maxlength="100"
                              />
                              <div v-if="validation_errors[field.model]" class="text-danger text-xs mt-1">{{ validation_errors[field.model] }}</div>
                              <div v-if="validation_errors[field.other_model]" class="text-danger text-xs mt-1">{{ validation_errors[field.other_model] }}</div>
                            </div>
                          </div>
                        </div>

                        <div class="text-center mt-2 mb-3" v-if="(language_blocks[section.id] || []).length < (_all_language_blocks_by_section && _all_language_blocks_by_section[section.id] ? _all_language_blocks_by_section[section.id].length : 0)">
                          <button
                            type="button"
                            class="btn btn-sm text-xxs shadow btn-primary-dark"
                            @click="add_language_block(section.id)"
                          >
                            Add another language
                          </button>
                        </div>
                      </template>

                      <template v-if="section.has_education_cards && education_blocks[section.id]">
                        <div
                          class="we-block-card mb-4 p-4 border rounded-3"
                          v-for="(block, bidx) in education_blocks[section.id]"
                          :key="'edu-block-' + section.id + '-' + bidx"
                        >
                          <div class="we-block-header d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                            <p class="d-none fw-bold text-xs mb-0 text-dark">
                              <i class="bi bi-mortarboard me-1"></i>
                              {{ block.label }}
                            </p>
                            <button
                              v-if="education_blocks[section.id].length > 1"
                              type="button"
                              class="btn btn-sm border-0 text-danger"
                              @click="remove_education_block(section.id, bidx)"
                              title="Remove this qualification"
                            >
                              <i class="bi bi-trash"></i>
                            </button>
                          </div>

                          <div class="we-fields-grid row g-3">
                            <div v-for="(field, fidx) in block.fields" :key="'edu-field-' + bidx + '-' + fidx" class="we-form-group col-md-4" :data-field-model="field.model">
                              <label class="form-label fw-medium text-xs text-start d-block">{{ field.label }} <span v-if="field.required" class="text-danger">*</span></label>

                              <!-- Year obtained is always treated as attained and capped to current year. -->
                              <template v-if="field.key === 'year_obtained'">
                                <select
                                  class="form-select form-select-sm text-xs  border-1 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  v-model="safe_form_data[field.model]"
                                  :required="field.required"
                                  @change="validate_edu_year_obtained(field)"
                                >
                                  <option value="">Select...</option>
                                  <option v-for="opt in get_edu_year_options()" :key="'opt-' + field.model + '-' + opt.value" :value="opt.value">{{ opt.text }}</option>
                                </select>
                              </template>

                              <select
                                v-else-if="field.type === 'single_select'"
                                class="form-select form-select-sm text-xs  border-1 py-1 rounded-lg"
                                :class="{'border-danger': validation_errors[field.model]}"
                                v-model="safe_form_data[field.model]"
                                :required="field.required"
                              >
                                <option value="">Select...</option>
                                <option v-for="opt in (field.options || [])" :key="'opt-' + field.model + '-' + opt.value" :value="opt.value">{{ opt.text }}</option>
                              </select>
                              <input
                                v-else
                                type="text"
                                class="form-control form-control-sm text-xs  border-1 py-1 rounded-lg"
                                :class="{'border-danger': validation_errors[field.model]}"
                                v-model="safe_form_data[field.model]"
                                :placeholder="field.placeholder || field.label"
                                :required="field.required"
                                maxlength="100"
                              />
                              <div v-if="validation_errors[field.model]" class="text-danger text-xs mt-1">{{ validation_errors[field.model] }}</div>
                            </div>
                          </div>
                        </div>

                        <div class="text-center mt-2 mb-3" v-if="(education_blocks[section.id] || []).length < (_all_education_blocks_by_section && _all_education_blocks_by_section[section.id] ? _all_education_blocks_by_section[section.id].length : 0)">
                          <button
                            type="button"
                            class="btn btn-sm text-xxs shadow btn-primary-dark"
                            @click="add_education_block(section.id)"
                          >
                            Add another qualification
                          </button>
                        </div>
                      </template>

                      <template v-if="section.has_reference_cards && reference_blocks[section.id]">
                        <div
                          class="we-block-card mb-4 p-4 border rounded-3"
                          v-for="(block, bidx) in reference_blocks[section.id]"
                          :key="'ref-block-' + section.id + '-' + bidx"
                        >
                          <div class="we-block-header d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                            <p class="d-none fw-bold text-xs mb-0 text-dark">
                              <i class="bi bi-people me-1"></i>
                              {{ block.label }}
                            </p>
                            <button
                              v-if="reference_blocks[section.id].length > 1"
                              type="button"
                              class="btn btn-sm border-0 text-danger"
                              @click="remove_reference_block(section.id, bidx)"
                              title="Remove this reference"
                            >
                              <i class="bi bi-trash"></i>
                            </button>
                          </div>

                          <div class="we-fields-grid row g-3">
                            <div v-for="(field, fidx) in block.fields" :key="'ref-field-' + bidx + '-' + fidx" class="we-form-group col-md-4" :data-field-model="field.model">
                              <label class="form-label fw-medium text-xs text-start d-block">{{ field.label }} <span v-if="field.required" class="text-danger">*</span></label>
                              <select
                                v-if="field.type === 'single_select'"
                                class="form-select form-select-sm text-xs  border-1 py-1 rounded-lg"
                                :class="{'border-danger': validation_errors[field.model]}"
                                v-model="safe_form_data[field.model]"
                                :required="field.required"
                              >
                                <option value="">Select...</option>
                                <option v-for="opt in (field.options || [])" :key="'opt-' + field.model + '-' + opt.value" :value="opt.value">{{ opt.text }}</option>
                              </select>
                              <input
                                v-else-if="field.type === 'phone'"
                                type="tel"
                                class="form-control form-control-sm text-xs  border-1 py-1 rounded-lg"
                                :class="{'border-danger': validation_errors[field.model]}"
                                :value="get_phone_display(field.model)"
                                :placeholder="field.placeholder || '+27 82 123 4567'"
                                :required="field.required"
                                maxlength="22"
                                @input="on_phone_input($event, field)"
                                @blur="on_phone_blur(field)"
                              />
                              <input
                                v-else
                                type="text"
                                class="form-control form-control-sm text-xs  border-1 py-1 rounded-lg"
                                :class="{'border-danger': validation_errors[field.model]}"
                                v-model="safe_form_data[field.model]"
                                :placeholder="field.placeholder || field.label"
                                :required="field.required"
                                maxlength="100"
                              />
                              <input
                                v-if="field.allows_other && (safe_form_data[field.model] || '').toLowerCase() === 'other'"
                                type="text"
                                class="form-control form-control-sm text-xs  border-1 py-1 rounded-lg mt-2"
                                :data-field-model="field.other_model"
                                :class="{'border-danger': validation_errors[field.other_model]}"
                                v-model="safe_form_data[field.other_model]"
                                placeholder="Please specify"
                                maxlength="100"
                              />
                              <div v-if="validation_errors[field.model]" class="text-danger text-xs mt-1">{{ validation_errors[field.model] }}</div>
                              <div v-if="validation_errors[field.other_model]" class="text-danger text-xs mt-1">{{ validation_errors[field.other_model] }}</div>
                            </div>
                          </div>
                        </div>

                        <div class="text-center mt-2 mb-3" v-if="(reference_blocks[section.id] || []).length < (_all_reference_blocks_by_section && _all_reference_blocks_by_section[section.id] ? _all_reference_blocks_by_section[section.id].length : 0)">
                          <button
                            type="button"
                            class="btn btn-sm text-xxs shadow btn-primary-dark"
                            @click="add_reference_block(section.id)"
                          >
                            Add another reference
                          </button>
                        </div>
                      </template>

                      <template v-if="section.fields && section.fields.length">
                        <div class="">
                          <div v-if="section.is_work_experience" class="mt-3 mb-2">
                            <p class="text-xs fw-bold mb-1">Additional Questions</p>
                          </div>
                          <template v-for="(field, field_index) in section.fields" :key="'field-' + field_index">
                            
                            <div
                              class="form-group"
                              :class="[
                                field.type === 'textarea' ? 'col-12' : 'col-md-12',
                                { 'readonly-prepopulated-field': is_locked_advertised_post_field(section, field_index, field) }
                              ]"
                              v-if="field && field.model && safe_form_data && !field.is_dependent"
                              :data-field-model="field.model"
                            >
                              <label :for="field.id" class="fw-medium text-xs text-start d-block mt-3" v-if="field.label">
                                {{ field.label }}
                                <span v-if="field.required" class="text-danger fs-4">*</span>
                              </label>

                              <input v-if="field.type === 'text'" type="text"
                                class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg"
                                :class="{
                                  'border-danger': validation_errors[field.model],
                                  'locked-prepopulated-control': is_locked_advertised_post_field(section, field_index, field)
                                }" :id="field.id || ''"
                                :style="locked_advertised_post_style(section, field_index, field)"
                                v-model="safe_form_data[field.model]" :placeholder="field.placeholder"
                                :required="field.required"
                                :readonly="is_locked_advertised_post_field(section, field_index, field)"
                                :disabled="is_locked_advertised_post_field(section, field_index, field)"
                                maxlength="30" />

                              <textarea v-else-if="field.type === 'textarea'"
                                class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg"
                                :class="{
                                  'border-danger': validation_errors[field.model],
                                  'locked-prepopulated-control': is_locked_advertised_post_field(section, field_index, field)
                                }" :id="field.id || ''"
                                :style="locked_advertised_post_style(section, field_index, field)"
                                v-model="safe_form_data[field.model]" :placeholder="field.placeholder" :rows="field.rows || 3"
                                :required="field.required"
                                :readonly="is_locked_advertised_post_field(section, field_index, field)"
                                :disabled="is_locked_advertised_post_field(section, field_index, field)"
                                maxlength="30"></textarea>

                              <input v-else-if="field.type === 'number'" type="text" @input="handleNumberInput($event, field)"
                                class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg"
                                :class="{
                                  'border-danger': validation_errors[field.model],
                                  'locked-prepopulated-control': is_locked_advertised_post_field(section, field_index, field)
                                }" :id="field.id || ''"
                                :style="locked_advertised_post_style(section, field_index, field)"
                                v-model="safe_form_data[field.model]" :placeholder="field.placeholder"
                                :required="field.required"
                                :readonly="is_locked_advertised_post_field(section, field_index, field)"
                                :disabled="is_locked_advertised_post_field(section, field_index, field)" />

                              <input v-else-if="field.type === 'date'" type="date"
                                class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg"
                                :class="{
                                  'border-danger': validation_errors[field.model],
                                  'locked-prepopulated-control': is_locked_advertised_post_field(section, field_index, field)
                                }" :id="field.id || ''"
                                :style="locked_advertised_post_style(section, field_index, field)"
                                v-model="safe_form_data[field.model]" :required="field.required"
                                :readonly="is_locked_advertised_post_field(section, field_index, field)"
                                :disabled="is_locked_advertised_post_field(section, field_index, field)" />

                              <div v-else-if="field.type === 'facial_verification'" class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg">
                                <div v-if="safe_form_data[field.model] && safe_form_data[field.model].file_name">
                                  <div class="d-flex align-items-center gap-2">
                                    <span class="text-xs text-truncate">{{ safe_form_data[field.model].file_name }}</span>
                                    <button
                                      class="btn-sm text-xxs shadow btn-primary-dark"
                                      type="button"
                                      @click="preview_local_file(field.model)"
                                      aria-label="Preview file"
                                      title="Preview file"
                                    >
                                      <i class="bi bi-eye"></i>
                                    </button>
                                    <button
                                      class="btn-sm text-xxs shadow btn-primary-dark"
                                      type="button"
                                      @click="remove_file(field.model)"
                                      aria-label="Remove file"
                                      title="Remove file"
                                    >
                                      <i class="bi bi-trash"></i>
                                    </button>
                                  </div>
                                </div>
                                <div v-else class="w-100">
                                  <FacialBiometric :question="field" v-model="safe_form_data[field.model]" />
                                </div>
                              </div>

                              <div v-else-if="field.type === 'file'">
                                <div v-if="safe_form_data[field.model] && safe_form_data[field.model]" class="form-control clean-field-control d-flex align-items-center">
                                  <div class="d-flex align-items-center gap-2">
                                    <span class="text-xs text-truncate">{{ safe_form_data[field.model].file_name }}</span>
                                    <button
                                      class="btn-sm text-xxs shadow btn-primary-dark"
                                      type="button"
                                      @click="preview_local_file(field.model)"
                                      aria-label="Preview file"
                                      title="Preview file"
                                    >
                                      <i class="bi bi-eye"></i>
                                    </button>
                                    <button
                                      class="btn-sm text-xxs shadow btn-primary-dark"
                                      type="button"
                                      @click="remove_file(field.model)"
                                      aria-label="Remove file"
                                      title="Remove file"
                                    >
                                      <i class="bi bi-trash"></i>
                                    </button>
                                  </div>
                                </div>
                                <div v-else>
                                  <input type="file"
                                    accept=".pdf"
                                    class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg"
                                    :id="field.id || ''" @change="handle_file_upload($event, field.section_question_id)"
                                    :required="field.required" />
                                  <small class="text-muted text-xxs">Only PDF files are accepted</small>
                                  <div v-if="file_validation_error[field.id]" class="text-danger text-xs mt-1">{{file_validation_error[field.id]}}</div>
                                </div>
                              </div>

                              <!-- PDF-only file upload -->
                              <div v-else-if="field.type === 'pdf_file'">
                                <div v-if="safe_form_data[field.model] && safe_form_data[field.model]" class="form-control clean-field-control d-flex align-items-center">
                                  <div class="d-flex align-items-center gap-2">
                                    <span class="text-xs text-truncate">{{ safe_form_data[field.model].file_name }}</span>
                                    <button
                                      class="btn-sm text-xxs shadow btn-primary-dark"
                                      type="button"
                                      @click="preview_local_file(field.model)"
                                      aria-label="Preview file"
                                      title="Preview file"
                                    >
                                      <i class="bi bi-eye"></i>
                                    </button>
                                    <button
                                      class="btn-sm text-xxs shadow btn-primary-dark"
                                      type="button"
                                      @click="remove_file(field.model)"
                                      aria-label="Remove file"
                                      title="Remove file"
                                    >
                                      <i class="bi bi-trash"></i>
                                    </button>
                                  </div>
                                </div>
                                <div v-else>
                                  <input type="file"
                                    accept=".pdf"
                                    class="form-control form-control-sm text-xs  border-2 py-1 rounded-lg"
                                    :id="field.id || ''" @change="handle_file_upload($event, field.section_question_id)"
                                    :required="field.required" />
                                  <small class="text-muted text-xxs">Only PDF files are accepted</small>
                                  <div v-if="file_validation_error[field.id]" class="text-danger text-xs mt-1">{{file_validation_error[field.id]}}</div>
                                </div>
                              </div>

                              <div v-else-if="field.type === 'single_select' || field.type === 'radio'" class="radio-group mt-2"
                                :class="{'border border-danger rounded p-2': submit_attempted && validation_errors[field.model], 'readonly-choice-group': field.is_readonly_prepopulated}">
                                <label
                                  v-for="(option, opt_index) in field.options || []"
                                  :key="'radio-' + opt_index"
                                  class="d-flex align-items-center gap-2 mb-2 w-100"
                                  :for="`${field.id}-${opt_index}`"
                                >
                                  <input class="form-check-input position-static m-0" type="radio" :name="field.id || ''"
                                    :id="`${field.id}-${opt_index}`" v-model="safe_form_data[field.model]"
                                    :value="option.value || option.text" :required="field.required"
                                    :disabled="field.is_readonly_prepopulated"
                                    @change="handle_select_change(field)" />
                                  <span class="form-check-label text-xs mb-0">
                                    {{ option.text }}
                                  </span>
                                </label>
                              </div>

                              <div v-else-if="field.type === 'multi_select' || field.type === 'checkboxes'" class="mt-2"
                                :class="{'border border-danger rounded p-2': submit_attempted && validation_errors[field.model], 'readonly-choice-group': field.is_readonly_prepopulated}">
                                <div v-for="(option, opt_index) in field.options || []" :key="'checkbox-' + opt_index" class="form-check mb-1">
                                  <input class="form-check-input" type="checkbox" :id="`${field.id}-${opt_index}`"
                                    :value="option.value || option.text" v-model="safe_form_data[field.model]"
                                    :disabled="field.is_readonly_prepopulated"
                                    @change="handle_select_change(field)" />
                                  <label class="form-check-label text-xs ms-1" :for="`${field.id}-${opt_index}`">
                                    {{ option.text }}
                                  </label>
                                </div>
                              </div>

                              <div v-else-if="field.type === 'sa_id_number'">
                                <input
                                  type="text"
                                  class="form-control form-control-lg text-xs  border-2 py-1 rounded-lg"
                                  :class="{
                                    'border-danger': validation_errors[field.model],
                                    'locked-prepopulated-control': field.is_readonly_prepopulated
                                  }"
                                  :id="field.id || ''"
                                  v-model="safe_form_data[field.model]"
                                  :placeholder="field.placeholder"
                                  :required="field.required"
                                  :readonly="field.is_readonly_prepopulated"
                                  maxlength="13"
                                  @input="validate_sa_id_on_input(field)"
                                  @blur="validate_sa_id_on_blur(field)"
                                />
                              </div>

                              <!-- Phone (single field with country code + number) -->
                              <div v-else-if="field.type === 'phone'">
                                <input
                                  type="tel"
                                  class="form-control form-control-lg text-xs  border-2 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  :id="field.id || ''"
                                  :value="get_phone_display(field.model)"
                                  :placeholder="get_phone_placeholder(field.model)"
                                  :required="field.required"
                                  maxlength="22"
                                  @input="on_phone_input($event, field)"
                                  @blur="on_phone_blur(field)"
                                />
                              </div>

                              <!-- Fax -->
                              <div v-else-if="field.type === 'fax'">
                                <input
                                  type="tel"
                                  class="form-control form-control-lg text-xs  border-2 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  :id="field.id || ''"
                                  v-model="safe_form_data[field.model]"
                                  :placeholder="field.placeholder || '0XX XXX XXXX'"
                                  :required="field.required"
                                  maxlength="15"
                                  @input="validate_contact_on_input(field)"
                                  @blur="validate_contact_on_blur(field)"
                                />
                              </div>

                              <!-- Email -->
                              <div v-else-if="field.type === 'email'">
                                <input
                                  type="email"
                                  class="form-control form-control-lg text-xs  border-2 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  :id="field.id || ''"
                                  v-model="safe_form_data[field.model]"
                                  :placeholder="field.placeholder || 'name@example.com'"
                                  :required="field.required"
                                  @input="validate_contact_on_input(field)"
                                  @blur="validate_contact_on_blur(field)"
                                />
                              </div>

                              <!-- Postal Code -->
                              <div v-else-if="field.type === 'postal_code'">
                                <input
                                  type="text"
                                  class="form-control form-control-lg text-xs  border-2 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  :id="field.id || ''"
                                  v-model="safe_form_data[field.model]"
                                  :placeholder="field.placeholder || '0000'"
                                  :required="field.required"
                                  maxlength="4"
                                  @input="validate_contact_on_input(field)"
                                  @blur="validate_contact_on_blur(field)"
                                />
                              </div>

                              <!-- Passport Number -->
                              <div v-else-if="field.type === 'passport_number'">
                                <input
                                  type="text"
                                  class="form-control form-control-lg text-xs  border-2 py-1 rounded-lg"
                                  :class="{'border-danger': validation_errors[field.model]}"
                                  :id="field.id || ''"
                                  v-model="safe_form_data[field.model]"
                                  :placeholder="field.placeholder || 'e.g. A01234567'"
                                  :required="field.required"
                                  maxlength="9"
                                  @input="validate_contact_on_input(field)"
                                  @blur="validate_contact_on_blur(field)"
                                />
                              </div>

                              <input v-else type="text"
                                class="form-control form-control-lg text-xs  border-2 py-1 rounded-lg"
                                :class="{
                                  'border-danger': validation_errors[field.model],
                                  'locked-prepopulated-control': field.is_readonly_prepopulated
                                }" :id="field.id || ''"
                                v-model="safe_form_data[field.model]" :placeholder="field.placeholder"
                                :required="field.required"
                                :readonly="field.is_readonly_prepopulated"
                                @input="update_dependent_questions_visibility(field, safe_form_data[field.model])" />

                              <div v-if="validation_errors[field.model]" class="text-danger text-xs mt-1">
                                {{ validation_errors[field.model] }}
                              </div>

                              <div class="mt-3 w-100">
                                <RecursiveDependentQuestions v-if="(field.dependent_questions || []).filter(Boolean).length"
                                  :questions="(field.dependent_questions || []).filter(Boolean)" :form_data="safe_form_data"
                                  :validation_errors="validation_errors" :file_validation_error="file_validation_error"
                                  :submit_attempted="submit_attempted"
                                  :update_dependent_questions_visibility="update_dependent_questions_visibility"
                                  :sa_id_validation_errors="sa_id_validation_errors"
                                  :sa_id_validation_messages="sa_id_validation_messages"
                                  :sa_id_validation_details="sa_id_validation_details"
                                  @update-field="on_update_field"
                                  @number-input="({ event, node }) => handleNumberInput(event, node)"
                                  @file-upload="handle_file_upload" @preview-file="preview_local_file"
                                  @remove-file="remove_file"
                                  @validate-sa-id-on-input="handle_sa_id_validation_input"
                                  @validate-sa-id-on-blur="handle_sa_id_validation_blur"
                                  @validate-contact-on-input="handle_contact_validation_input"
                                  @validate-contact-on-blur="handle_contact_validation_blur" />
                              </div>
                            </div>
                          </template>
                        </div> 
                      </template> 
                    </div>

                    <div
                      class="form-footer-clean mt-4 pb-3"
                      :class="{ 'final-submit-layout': section_index === safe_form_config.sections.length - 1 && (!can_preview_submission || is_job_application) }"
                    >
                      <div class="footer-actions desktop-footer-actions d-none d-md-flex align-items-center gap-2 flex-wrap">
                        <button
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark desktop-back-btn"
                          @click="goToPrevSection"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="Previous Section"
                          :disabled="current_section_index === 0"
                          v-if="safe_form_config.sections?.length > 1">
                          <i class="bi bi-chevron-left"></i>
                          <span class="nav-arrow-label">Back</span>
                        </button>

                        <button
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark"
                          @click="confirm_clear_current_section(section)"
                          type="button"
                        >
                          Clear
                        </button>

                        <button
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark desktop-next-btn"
                          @click="goToNextSection"
                          type="button"
                          v-if="section_index !== safe_form_config.sections.length - 1 && safe_form_config.sections?.length > 1"
                        >
                          Continue
                        </button>

                        <button
                          v-if="section_index === safe_form_config.sections.length - 1 && (can_preview_submission || is_job_application)"
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark"
                          @click="generate_form_preview"
                          :disabled="preview_blocked_by_required_confirmation || is_preview_loading"
                          type="button"
                        >
                          {{ is_preview_loading ? 'Loading Preview...' : 'Preview' }}
                        </button>

                        <button
                          v-if="section_index === safe_form_config.sections.length - 1 && !can_preview_submission && !is_job_application"
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark"
                          @click="submit_answers"
                          type="button"
                        >
                          {{ submit_button_text }}
                        </button>
                      </div>

                      <div class="footer-actions footer-nav-actions d-flex align-items-center gap-2 flex-wrap">
                        <button
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark nav-arrow nav-prev"
                          @click="goToPrevSection" 
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="Previous Section"
                          :disabled="current_section_index === 0"
                          v-if="safe_form_config.sections?.length > 1">
                          <i class="bi bi-chevron-left"></i>
                          <span class="nav-arrow-label">Back</span>
                        </button>

                        <button
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark nav-arrow"
                          @click="confirm_clear_current_section(section)"
                          type="button"
                        >
                          Clear
                        </button>

                        <button
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark nav-arrow nav-next"
                          @click="goToNextSection"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="Next Section"
                          v-if="section_index !== safe_form_config.sections.length - 1 && safe_form_config.sections?.length > 1">
                          <i class="bi bi-chevron-right"></i>
                          <span class="nav-arrow-label">Continue</span>
                        </button>

                        <!-- Preview button on last section when template preview is available -->
                        <button v-if="section_index === safe_form_config.sections.length - 1 && (can_preview_submission || is_job_application)"
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark nav-arrow footer-final-action-btn"
                          @click="generate_form_preview"
                          :disabled="preview_blocked_by_required_confirmation || is_preview_loading">
                          {{ is_preview_loading ? 'Loading Preview...' : 'Preview' }}
                        </button>

                        <!-- Submit button on last section when no template preview is available -->
                        <button v-if="section_index === safe_form_config.sections.length - 1 && !can_preview_submission && !is_job_application"
                          class="btn btn-sm rounded-small text-xs shadow text-dark btn-primary-dark nav-arrow footer-final-action-btn"
                          @click="submit_answers">
                          {{ submit_button_text }}
                        </button>
                      </div>
                </div>
              </div>
            </template>
          </div>
        </div>

            <div v-if="show_form_preview" class="form-wrapper active" :data-index="safe_form_config.sections.length">
              <div class="form-card-clean shadow-sm">
                <div class="form-header-clean mb-4" v-if="safe_form_config.form_title">
                  <h1 class="main-title">{{ safe_form_config.form_title }}</h1>
                </div>

                <div class="form-fields-container pb-3">
                  <div class="section-heading pb-2 border-bottom mb-4 d-flex align-items-center gap-2">
                    <i class="bi bi-eye"></i> Form Preview
                  </div>

                  <div class="docuseal-preview-wrapper rounded-lg overflow-hidden border  shadow-sm">
                    <div v-if="form_preview_url" class="preview-container">
                      <docuseal-form
                        :data-src="form_preview_url"
                        data-expand="true"
                        data-with-download-button="true"
                        data-with-send-copy-button="false"
                        data-remember-signature="true"
                        data-with-title="false"
                        >
                      </docuseal-form>
                    </div>
                    <div v-else-if="is_preview_loading || preview_status_message" class="text-center text-muted py-5 d-flex flex-column align-items-center justify-content-center preview-loading-state">
                      <div class="spinner-border text-primary mb-3" role="status"></div>
                      <i class="bi bi-hourglass-split fs-3 d-block mb-2"></i>
                      {{ preview_status_message || 'Loading preview...' }}
                    </div>
                    <div v-else class="text-center text-muted py-5 d-flex flex-column align-items-center justify-content-center preview-loading-state">
                      <i class="bi bi-exclamation-circle fs-3 d-block mb-2 text-danger"></i>
                      <p class="mb-2">{{ preview_error_message || 'Preview is not available yet.' }}</p>
                      <small class="text-muted">Check the browser console for Z83 preview logs.</small>
                    </div>
                  </div>

              <!-- Action Buttons -->
              <div class="d-flex justify-content-between mt-4 px-1">
                <button class="btn btn-sm text-xs shadow btn-primary-dark" @click="exit_preview">
                  Back to Edit
                </button>

                <button class="btn btn-sm text-xs shadow btn-primary-dark"
                  @click="submit_answers">
                  Submit Application
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
        </main>
      </div>
    </div>
</div>



  <!-- Modal for file preview -->
    <div v-if="preview_modal" class="custom-modal-overlay" @click.self="preview_modal = false">
      <FilePreviewComponent :file="preview_url" @close="close_the_file_preview" :key="preview_url" />
    </div>

    <!-- Modal for file preview -->
    <teleport to="body">
      <div v-if="show_file_preview_modal" class="aic-modal-overlay" @click.self="close_file_preview_modal">
        <div class="modal-dialog aic-modal-dialog">
          <div class="modal-content aic-modal-content bg-white rounded-3 p-0 shadow-lg" @click.stop>
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <h5 class="modal-title text-white text-xxs">File Preview</h5>
              <button type="button" class="modal-btn-close btn-close" @click="close_file_preview_modal"
                aria-label="Close"></button>
            </div>

            <div class="modal-body aic-modal-body p-0">
              <img v-if="preview_url && preview_type === 'image'" :src="preview_url" :alt="preview_name || 'Preview'" />
              <video v-else-if="preview_url && preview_type === 'video'" :src="preview_url" controls></video>
              <iframe v-else-if="preview_url" :src="preview_url" frameborder="0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </teleport>

    <!-- Modal for request information -->
    <teleport to="body">
      <div v-if="show_request_info_modal" class="modal show" @click="close_request_info_modal">
        <div class="modal show d-block" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
              <div class="modal-header border-bottom-0 cute-header shadow-lg">
                <p class="modal-title text-white text-xxs">Request Information</p>
                <button type="button" class="modal-btn-close btn-close" @click="close_request_info_modal"
                  aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div v-if="answered_file_questions.length > 0" class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <p class="text-xxs fw-bold mb-0">Files in current section:</p>
                  </div>
                  <div class="mt-3">
                    <div v-for="question in answered_file_questions" :key="question.section_question_id"
                      class="file-list-item">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                          <i class="bi bi-file-earmark me-2 text-primary"></i>
                          <div>
                            <div class="text-xxs">{{ question.question_text }}</div>
                          </div>
                        </div>
                        <input type="checkbox" :value="question.section_question_id"
                          :data-requested_field_text="question.question_text" class="form-check-input ms-3"
                          @change="toggle_requested_field($event, question)" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-form-group form-group mb-2 d-flex flex-column">
                  <label for="request_info_note" class="modal-form-label form-label text-start text-xxs">Notes</label>
                  <textarea v-model="request_info_note" id="request_info_note"
                    class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" rows="4"></textarea>
                </div>
              </div>
              <div class="modal-footer border-0 p-2 d-flex justify-content-end">
                <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                  @click="request_information">Request</button>
                <button type="button" class="btn btn-primary-dark btn-sm text-xxs ms-2"
                  @click="close_request_info_modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </teleport>
</template>
